import { ClubOnboardingSettingsDTO } from "@gymflow/types";
import { AxiosInstance } from "axios";

const onboardingSettingsAsMemberApi = (
  axiosInstance: AxiosInstance,
  clubId: number,
) => {
  const clubPrefix = `club/${clubId}/`;

  return {
    getAll() {
      return axiosInstance.get<ClubOnboardingSettingsDTO>(
        `${clubPrefix}customer/onboarding-settings`,
      );
    },
  };
};

export default onboardingSettingsAsMemberApi;
